import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import plusImage from "../../../common/images/plus.svg";
import {
    setIsCreateCertificateModalOpen,
    setSelectedEmployee,
    setSelectedQualification,
} from "../../../modals/CreateCertificateModal/CreateCertificateModalSlice";
import { Dispatch } from "redux";
import { QualificationInterface } from "../../../common/interfaces/QualificationInterface";
import { getFunctionGroupLabel } from "../../../common/utils/getFunctionGroupLabel";
import { getUserFullName } from "../../../common/utils/getUserFullName";

interface Props {
    employeeData: EmployeeInterface[];
}

interface ReturnRow {
    id: number;
    columns: {
        value: string;
        onLinkClick?: () => void;
    }[];
}

export const mapUnachievedEmployeeDataToRows = (
    dispatch: Dispatch,
    qualification: QualificationInterface,
    props: Props,
): ReturnRow[] => {
    const { employeeData } = props;

    if (!employeeData || !Array.isArray(employeeData)) {
        return [];
    }

    return (
        employeeData.map((employee, index) => ({
            id: employee.id || index,
            columns: [
                {
                    value: getUserFullName(employee.user) ?? "-",
                },
                {
                    value: employee?.function_groups.length
                        ? getFunctionGroupLabel(employee?.function_groups)
                        : "-",
                },
                {
                    value: "",
                    actionButton: {
                        iconUrl: plusImage,
                        backgroundColor: "#e67a01",
                        onClick: () => {
                            dispatch(setSelectedQualification(qualification));
                            dispatch(setSelectedEmployee(employee));
                            dispatch(setIsCreateCertificateModalOpen(true));
                        },
                    },
                },
            ],
        })) || []
    );
};
